import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import artItemReducer from '../redux/slices/artItemSlice';
import artDetailsReducer from '../redux/slices/artDetailsSlice';
import cartSliceReducer from '../redux/slices/cartVisibilitySlice';
import checkoutSliceReducer from '../redux/slices/checkoutSlice';
import createStoreReducer from "../redux/slices/createStoreSlice";
import createProductReducer from "../redux/slices/createProductSlice";
import authReducer from '../redux/slices/authSlice';
import selectedStoreReducer from '../redux/slices/selectedStoreSlice';
import { authApi } from './services/authApi';
import { userApi } from './services/userApi';
import { storesApi } from './services/storesApi';
import { productApi } from './services/productApi';
import { contactApi } from './services/contactApi';
import { dashboardApi } from './services/dashboardApi';
import { orderApi } from './services/orderApi';


const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['CreateStore', 'CreateProduct', 'auth'],
  blacklist: [
    authApi.reducerPath,
    userApi.reducerPath,
    storesApi.reducerPath,
    productApi.reducerPath,
    contactApi.reducerPath,
    dashboardApi.reducerPath,
    orderApi.reducerPath,
  ],
};

const rootReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [storesApi.reducerPath]: storesApi.reducer,
  [productApi.reducerPath]: productApi.reducer,
  [contactApi.reducerPath]: contactApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
  auth: authReducer,
  selectedStore: selectedStoreReducer,
  ArtDetailsVisibility: artDetailsReducer,
  CartState: cartSliceReducer,
  CheckoutState: checkoutSliceReducer,
  ArtItem: artItemReducer,
  CreateStore: createStoreReducer,
  CreateProduct: createProductReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(
      authApi.middleware, 
      userApi.middleware, 
      storesApi.middleware,
      productApi.middleware,
      contactApi.middleware,
      dashboardApi.middleware,
      orderApi.middleware
    ),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
setupListeners(store.dispatch);

// export const store = configureStore({
//   reducer: {
//     [authApi.reducerPath]: authApi.reducer,
//     [userApi.reducerPath]: userApi.reducer,
//     [storesApi.reducerPath]: storesApi.reducer,
//     [productApi.reducerPath]: productApi.reducer,
//     [contactApi.reducerPath]: contactApi.reducer,
//     [dashboardApi.reducerPath]: dashboardApi.reducer,
//     [orderApi.reducerPath]: orderApi.reducer,
//     auth: authReducer,
//     selectedStore: selectedStoreReducer,
//     ArtDetailsVisibility: artDetailsReducer,
//     CartState: cartSliceReducer,
//     CheckoutState: checkoutSliceReducer,
//     ArtItem: artItemReducer,
//     CreateStore: createStoreReducer,
//     CreateProduct: createProductReducer
//   },
//   middleware: (getDefaultMiddleware) => 
//     getDefaultMiddleware().concat(
//       authApi.middleware, 
//       userApi.middleware, 
//       storesApi.middleware,
//       productApi.middleware,
//       contactApi.middleware,
//       dashboardApi.middleware,
//       orderApi.middleware
//     ),
// });

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
// setupListeners(store.dispatch);